import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { NavigationRoutes } from '../../constant/Routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { blogLisitingRequest, deleteBlog } from './redux/blogDispatcher';
import { imageBaseUrls } from '../../constant/ApiUrls';
import placeholderImage from "../../components/assets/image/placeholder.png";


function BlogListingTable({ blogListing }) {


  const [page, setPage] = useState(0); // Starts from 0
  const [pageSize, setPageSize] = useState(10);


  console.log("blog listing-----", blogListing);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();



  const blocksListingHeading = [

    {
      field: "id", headerName: "NO", width: 40,
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (10 * page),
    },

    {
      field: "image_url", headerName: "Blog Image", width: 210,
      sortable: false,
      renderCell: (params) => {

        return (
          <img
            src={params.value ? `${imageBaseUrls(params.value)}` : placeholderImage}
            alt="Value"
            style={{ width: 200, height: 80, borderRadius: "10px" }}
          />
        );
      },
    },

    {

      field: "title", headerName: "Blog Title", width: 250
    },
    {

      field: "view_count", headerName: "Views", width: 100
    },
    {
      field: "created_at", // Make sure the field name is correct
      headerName: "Created At",
      width: 200,
      renderCell: (params) => {
        const rawDate = params.row.created_at;
        const date = new Date(rawDate);
        const formattedDate = date.toLocaleString(); // e.g. "5/9/2025, 8:17:14 AM"

        return <div>{formattedDate}</div>;
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 300,
      sortable: false,
      renderCell: (params, row) => {
        console.log("veiw is called", params, row);


        return (
          <div style={{
            display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
            height: "100%"
          }}>
            {/* <AddPlan
            buttonLabel="Edit"
            editMode={true}
            planData={params.row}
            categories={categories}

          /> */}


            <button
              onClick={() => {

                console.log("veiw is called",);
                navigate(NavigationRoutes.ADMIN_DASHBOARD + NavigationRoutes.EDIT_BLOG.replace(":id", `:${params.row.id}`));
              }}
              style={{
                backgroundColor: "#000000",
                color: "white",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px",
                fontSize: "10px",
                width: "100px",
                height: "24px",  // Increased height
                padding: "5px 5px", // Added padding
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              View
            </button>
            <button
              onClick={() => handleDelete(params.row)}
              style={{
                backgroundColor: "#F44336",
                color: "white",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px",
                fontSize: "10px",
                width: "30%",
                height: "24px",  // Increased height
                padding: "2px 5px", // Added padding
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Delete
            </button>






          </div>

        );
      },
    },


  ];


  const handleDelete = (row) => {
    console.log("Deleting Blog ID:", row);
    Swal.fire({
      title: ``,
      html:
        "" +
        "Are you sure?" +
        "<br>" +
        `You want to Delete blog "${row.title}"`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Delete`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(deleteBlog(row.id,));
      }
    });

    // Add your delete logic here
  };


  React.useEffect(() => {


    dispatch(blogLisitingRequest(page + 1, pageSize));
  }, [dispatch, page, pageSize, location.pathname]);

  return (

    <Paper sx={{ height: "95  %", width: '100%' }}>


      <div style={{ padding: "10px", justifyItems: "end" }}>
        <button
          onClick={() => {

            console.log("veiw is called",);
            navigate(NavigationRoutes.ADMIN_DASHBOARD + NavigationRoutes.ADD_BLOG);

          }}
          style={{
            backgroundColor: "#000000",
            color: "white",
            border: "none",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "10px",
            width: "100px",
            height: "24px",  // Increased height
            padding: "5px 5px", // Added padding
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Add Blog
        </button>






      </div>




      <DataGrid
        rows={blogListing.blogListing || []}
        columns={blocksListingHeading || []}
        rowCount={blogListing.totalBlog || 0} // ✅ Total count from Redux
        paginationMode="server" // ✅ Enable manual pagination
        sortingMode="server"
        page={page}
        pageSize={pageSize}
        pageSizeOptions={[10, 25, 50]}
        loading={blogListing.loading}
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={(model) => {
          setPage(model.page);
          setPageSize(model.pageSize);
        }}

        rowHeight={80}
        checkboxSelection={false}
        sx={{ border: 0 }}

      />
    </Paper>
  );
}




//Getting the state from the store
const mapStateToProps = (state) => {
  console.log(
    "PERMISSSION:::::::::"
    , state.blogReducer);
  return {
    blogListing: state.blogReducer, // Add optional chaining
  };
};



//passing the blog Data  in fetchBlogs function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    blogLisitingRequest: () => dispatch({ "type": "GET_BLOG_REQUEST" }), // Corrected function name
  };
};




//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(BlogListingTable);
